export default __webpack_public_path__ + "static/Chitin-24b93644d9b6f159b128400e892d2cb3.png";